import http from 'utils/http';
import {
  getAgentDataSetsUrls,
  getAgentDataSetUrls,
  getAgentsUrl,
  getAgentTemplatesUrl,
  getAgentTemplateUrl,
  getAgentUrl,
  getIndustriesUrl
} from './apiUrls';
import { AgentResponse, IndustriesResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { DatasetResponse } from '../setting/knowledgeBase/types';

export function getAgents(workspaceId: string): Promise<{ data: AgentResponse[]; meta: MetaApiResponse }> {
  return http.get(getAgentsUrl(workspaceId));
}

export function getIndustries(): Promise<IndustriesResponse[]> {
  return http.get(getIndustriesUrl());
}

export function getAgent(workspaceId: string, id: string): Promise<AgentResponse> {
  return http.get(getAgentUrl(workspaceId, id));
}

export function createAgent(workspaceId: string, payload: FormData): Promise<AgentResponse> {
  return http.post(getAgentsUrl(workspaceId), payload);
}

export function updateAgent(workspaceId: string, id: string, payload: any): Promise<AgentResponse> {
  return http.patch(getAgentUrl(workspaceId, id), payload);
}

export function deleteAgent(workspaceId: string, id: number): Promise<AgentResponse> {
  return http.delete(getAgentUrl(workspaceId, id));
}

export function updateAgentConfig(workspaceId: string, id: string, payload: any): Promise<AgentResponse> {
  return http.patch(getAgentUrl(workspaceId, id), payload);
}

export function getAgentTemplates(
  workspaceId: string,
  params: any
): Promise<{ data: AgentResponse[]; meta: MetaApiResponse }> {
  return http.get(getAgentTemplatesUrl(workspaceId), params);
}

export function getAgentTemplate(workspaceId: string, id: string): Promise<AgentResponse> {
  return http.get(getAgentTemplateUrl(workspaceId, id));
}

export function cloneAgent(workspaceId: string, payload: { agent_template_id?: number }): Promise<AgentResponse> {
  return http.post(getAgentsUrl(workspaceId), payload);
}

export function getDataSets(
  workspaceId: string,
  agentId: string,
  params?: Record<string, any>
): Promise<{ data: DatasetResponse[]; meta: MetaApiResponse }> {
  return http.get(getAgentDataSetsUrls(workspaceId, agentId), params);
}

export function getDataSet(workspaceId: string, agentId: string, dataSetId: string): Promise<DatasetResponse> {
  return http.get(getAgentDataSetUrls(workspaceId, agentId, dataSetId));
}

export function createDataSet(workspaceId: string, agentId: string, payload: any): Promise<any> {
  return http.post(getAgentDataSetsUrls(workspaceId, agentId), payload);
}

export function updateDataSet(workspaceId: string, agentId: string, dataSetId: string, payload: any): Promise<any> {
  return http.put(getAgentDataSetUrls(workspaceId, agentId, dataSetId), payload);
}

export function deleteDataSet(workspaceId: string, agentId: string, id: string): Promise<String> {
  return http.delete(getAgentDataSetUrls(workspaceId, agentId, id));
}
